import React from 'react';
import { Link } from 'react-router-dom';

// import { closingDeals } from "../../common/data";

const PackageSalesDetail = ({title, data}) => {
    // console.log("TicketSalesDetail", data)
    return (
        <React.Fragment>
            <div >
                <div className="card-height-100">
                    <div className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">{title}</h4>
                        <div className="flex-shrink-0">
                            {/* <select className="form-select form-select-sm">
                                <option defaultValue="">Closed Deals</option>
                                <option value="1">Active Deals</option>
                                <option value="2">Paused Deals</option>
                                <option value="3">Canceled Deals</option>
                            </select> */}
                        </div>
                    </div>
                    <div className="card-body px-2">
                        <div className="table-responsive">
                            <table className="table table-bordered table-nowrap align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col" style={{ width: "30%" }}>ID</th>
                                        <th scope="col" style={{ width: "30%" }}>상품명</th>
                                        <th scope="col" style={{ width: "20%" }}>주문건</th>
                                        <th scope="col" style={{ width: "20%" }}>매출</th>
                                        <th scope="col" style={{ width: "20%" }}>취소건</th>
                                        <th scope="col" style={{ width: "20%" }}>취소액</th>
                                        <th scope="col" style={{ width: "20%" }}>옵션수</th>
                                        <th scope="col" style={{ width: "20%" }}>옵션매출</th>
                                        <th scope="col" style={{ width: "20%" }}>옵션취소건</th>
                                        <th scope="col" style={{ width: "20%" }}>옵션취소액</th>
                                        <th scope="col" style={{ width: "20%" }}>총액</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.keys(data).map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{item}</td>
                                            <td>{data[item]["name"]}
                                                {/* <img src={data[item]["상품명"]} alt="" className="avatar-xs rounded-circle me-2" /> */}
                                                {/* <Link to="#" className="text-body fw-medium">{data[item].salesRep}</Link> */}
                                                </td>
                                            <td>{String(data[item]["reserv_count"])} 개</td>
                                            <td>{String(data[item]["reserv_total"])} 원</td>
                                            <td>{String(data[item]["canceled_count"])} 개</td>
                                            <td>{String(data[item]["canceled_total"])} 원</td>

                                            <td>{String(data[item]["option_count"])} 개</td>
                                            <td>{String(data[item]["option_total"])} 원</td>
                                            <td>{String(data[item]["option_cancel_count"])} 개</td>
                                            <td>{String(data[item]["option_cancel_total"])} 원</td>

                                            <td>{String(data[item]["reserv_total"] + data[item]["option_total"] - data[item]["canceled_total"] - data[item]["option_cancel_total"])} 원</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PackageSalesDetail;